export const removeHtmlTags = (text: string) => {
  const regex = /(<([^>]+)>)/gi;
  const newString = text.replace(regex, "").replaceAll("&nbsp;", "");
  return newString;
};
